<template>
  <private-gym-page id="video-techniek-page" name="home" :has_fab="false">

    <f7-searchbar
        disable-button-text="Cancel"
        placeholder="Zoek een oefening (min 3 karakters)"
        v-model:value="query"
        :clear-button="true"
    ></f7-searchbar>

    <f7-block-title>
      Techniek training videos
    </f7-block-title>

    <f7-list class="list-strong list-outline list-dividers">
      <video-link-item v-for="(video, index) in videos_sorted"
                       :video="video"
                       :query="query"
                       :show="videoSheetStates[index]"
                       @opened="updateVideoSheetsState(index, true)"
                       @closed="updateVideoSheetsState(index, false)"
      >
      </video-link-item>
    </f7-list>
  </private-gym-page>


</template>

<script>

import PrivateGymPage from "./../_layouts/PrivateGymPage.vue";
import {f7, f7ready, theme} from 'framework7-vue';
import VideoSheet from "../../components/videos/VideoSheet.vue";
import VideoLinkItem from "../../components/videos/VideoLinkItem.vue";
import utility from "../../js/utility";

export default {
  components: {
    VideoLinkItem,
    VideoSheet,
    PrivateGymPage,
  },

  props: {
    f7route: Object,
    f7router: Object,
    has_fab: {default: false}
  },

  setup(props) {
    const {f7route, f7router} = props;
  },

  mixins: [],

  data: function () {
    return {
      theme,
      query: '',
      videoSheetStates: [],
      videos: [
        {
          title: "Alternating Lunge",
          src: "https://iframe.mediadelivery.net/embed/87707/9b2017af-fdc3-42b7-b73a-2b23057ee6f0"
        },
        {
          title: "Cable Tricep Pressdown met stang",
          src: "https://iframe.mediadelivery.net/embed/87707/436fb238-7225-4626-8a51-d377bb1781cf"
        },
        {
          title: "Cable Tricep Pressdown met touw",
          src: "https://iframe.mediadelivery.net/embed/87707/c6543898-d213-4d62-a778-87cd17b4e7c6"
        },
        {
          title: "Dumbell Squat",
          src: "https://iframe.mediadelivery.net/embed/87707/a5c76340-d971-4593-a56c-a5a3fee8f732"
        },
        {
          title: "Goblet Squat",
          src: "https://iframe.mediadelivery.net/embed/87707/b985c54f-2480-4458-bfa4-ccacbe9e17c6"
        },
        {
          title: "Hip Hinge",
          src: "https://iframe.mediadelivery.net/embed/87707/ad998c2b-5413-49fc-af2c-5309685d7d03"
        },
        {
          title: "Horizontal Chestpress",
          src: "https://iframe.mediadelivery.net/embed/87707/67529667-0411-45df-8748-a7af1d3295b4"
        },
        {
          title: "Horizontal Row",
          src: "https://iframe.mediadelivery.net/embed/87707/2900bddc-34fa-4041-b9a1-cab89132c2c7"
        },
        {
          title: "Kettlebell Deadlift",
          src: "https://iframe.mediadelivery.net/embed/87707/b28868a2-9d84-4400-b720-4e125a43dec0"
        },
        {
          title: "Kettlebell Halo",
          src: "https://iframe.mediadelivery.net/embed/87707/e42a554b-ea59-4727-9069-fcb94c3c7801"
        },
        {
          title: "Kettlebell Row",
          src: "https://iframe.mediadelivery.net/embed/87707/54fc70e3-8ea3-43a7-88a2-0e08d205a0b2"
        },
        {
          title: "Reverse Lunge",
          src: "https://iframe.mediadelivery.net/embed/87707/377e0217-0d53-43a9-a9ea-c95d498a3634"
        },
        {
          title: "Reverse Lunge met Kettlebell Twist",
          src: "https://iframe.mediadelivery.net/embed/87707/d0a555c5-1b89-4e1b-80c6-abf6b3bfeb47"
        },
        {
          title: "Squat",
          src: "https://iframe.mediadelivery.net/embed/87707/deda9c97-3f7f-410e-9940-d116cb4fcee3"
        },
        {
          title: "Suitcase Deadlift",
          src: "https://iframe.mediadelivery.net/embed/87707/cfa021c9-5a06-43f6-8eb0-f70a30a8dd77"
        },
        {
          title: "To High Plank",
          src: "https://iframe.mediadelivery.net/embed/87707/2c76c99f-f2d8-43dd-9102-99f49a883dae"
        },
        {
          title: "Vertical Row",
          src: "https://iframe.mediadelivery.net/embed/87707/3a4abc2d-8931-48c5-8e7b-5a78fdf29cc1",
        },
        {
          title: "Arnold Press",
          src: "https://iframe.mediadelivery.net/embed/87707/b303ba49-8000-42cf-8720-e563a6e84958"
        },
        {
          title: "Bulgarian Split Squat",
          src: "https://iframe.mediadelivery.net/embed/87707/72cc4802-110d-4123-a724-c1e99b13fca3"
        },
        {
          title: "Dips",
          src: "https://iframe.mediadelivery.net/embed/87707/44ffc2c6-c674-4bec-bbbf-fcb44b681579"
        },
        {
          title: "High Plank Reaches",
          src: "https://iframe.mediadelivery.net/embed/87707/144c023a-0948-44ed-a49d-0077a2e70261"
        },
        {
          title: "Hip Thruster Bench",
          src: "https://iframe.mediadelivery.net/embed/87707/27171e79-6964-495f-aebe-ef5b556c55bb"
        },
        {
          title: "Hip Thruster Variaties",
          src: "https://iframe.mediadelivery.net/embed/87707/50b50633-1ca9-4b6d-b197-0b4a15474ee6"
        },
        {
          title: "Seated Row",
          src: "https://iframe.mediadelivery.net/embed/87707/fa4b6bb2-ca5d-44f5-9046-58c73d0b9646"
        },
        {
          title: "Superman Pull-Up",
          src: "https://iframe.mediadelivery.net/embed/87707/b1d6724f-a5d1-48d9-b39e-8e0dd30fc26d"
        },
        {
          title: "Superman Tillt-Up",
          src: "https://iframe.mediadelivery.net/embed/87707/17c2f27a-6921-4a95-a14f-cac8bd1f2170"
        },
        {
          title: "Alternating Chest Press",
          src: "https://iframe.mediadelivery.net/embed/87707/01ebf012-1dc8-4e38-8bc2-134d74424736"
        },
        {
          title: "Australian Chin-Ups",
          src: "https://iframe.mediadelivery.net/embed/87707/35fb283d-d79f-4b09-b521-2e9a433bb8f1"
        },
        {
          title: "Australian Pull-Ups",
          src: "https://iframe.mediadelivery.net/embed/87707/1131fd9d-d41a-4c30-8c9a-1d636cb7993b"
        },
        {
          title: "Clapping Push-Ups",
          src: "https://iframe.mediadelivery.net/embed/87707/f18e9d10-341a-4350-aa44-bdcd6a568465"
        },
        {
          title: "Hardstyle Push-ups",
          src: "https://iframe.mediadelivery.net/embed/87707/611711c4-76cf-4a04-827a-2bcc812f3fb9"
        },
        {
          title: "Hardstyle Pull-Ups",
          src: "https://iframe.mediadelivery.net/embed/87707/9e4c9f78-a828-403e-acf5-6fd33d0c559b"
        },
        {
          title: "Dumbbell Curl Squat",
          src: "https://iframe.mediadelivery.net/embed/87707/aadfbd98-aff1-418c-9c34-f6d1f4e7d3a9"
        },
        {
          title: "Gorilla Row",
          src: "https://iframe.mediadelivery.net/embed/87707/8a3eb8dd-ea97-4618-99a4-7a5497e14b50"
        },
      ],
      myPhotoBrowserVideo: null,
    };
  },

  computed: {
    current_user() {
      return this.$store.state.current_user.data;
    },
    is_logged_in() {
      return this.$store.getters['current_user/token'].length > 0;
    },
    videos_sorted() {
      return utility.sortObjectByKey(this.videos, 'title');
    },
  },

  created() {
    //
  },

  mounted() {
    this.setVideoSheetsState();
  },

  methods: {
    openVideo() {
      this.myPhotoBrowserVideo.open();
    },
    setVideoSheetsState() {
      this.videos.forEach((video, index) => {
        this.videoSheetStates.push(false);
      })
    },
    updateVideoSheetsState(index, state) {
      this.videoSheetStates[index] = state;
    }
  },

  watch: {
    //
  }
};
</script>
<style>

</style>
